import * as React from 'react';
import { CreateBase, Form, Toolbar } from 'react-admin';
import { Card, CardContent, Box } from '@mui/material';

import { ContractorOwnerInputs } from './ContractorOwnerInputs';

export const ContractorOwnerCreate = () => {
    return (
        <CreateBase
            redirect="show"
        >
            <Box mt={2} display="flex">
                <Box flex="1">
                    <Form>
                        <Card>
                            <CardContent>
                                <ContractorOwnerInputs />
                            </CardContent>
                            <Toolbar />
                        </Card>
                    </Form>
                </Box>
            </Box>
        </CreateBase>
    );
};
